/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable */
import { Col, Row, Form, Select, Input, Button, Divider, Radio, InputNumber } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ReactComponent as IconReloj } from 'assets/images/monitoreos/SIMAC_Icono_reloj.svg';
import { useSelector } from 'react-redux';
import {
  selectTipoHallazgoByIdMonitoreo,
  selectCatalogByName
} from 'selectors/catalogos.selectors';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { Accordion, AddButton, UploadMedia } from 'components';
import { ATRIBUTOS, UNIDADES_MEDIDA } from 'constants/nombresCatalogos';
import { MONITOREOS_VISITAS_VERIFICACION } from 'constants/tipoMonitoreos';
import './Hallazgos.scss';
import 'containers/Monitoreos/Formulario.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const Hallazgos = ({ form, isLoadingImages }) => {
  const tipoHallazgos = useSelector(
    selectTipoHallazgoByIdMonitoreo(MONITOREOS_VISITAS_VERIFICACION)
  );
  const atributos = useSelector(selectCatalogByName(ATRIBUTOS));
  const tiposMedida = useSelector(selectCatalogByName(UNIDADES_MEDIDA));

  const findAtributoByName = (nombreAtributo) => {
    const idAtributo = atributos.find(
      (atributo) => atributo.atributo === nombreAtributo
    )?.idAtributo;
    return idAtributo.toString();
  };

  const onChangeTipoHallazgo = (index) => {
    // console.log('index', index);
    form.setFieldsValue({
      hallazgos: {
        [index]: {
          cantidad: null,
          idINE: null,
          lema: null,
          subTipoHallazgo: null,
          tipoMedida: null,
          medida: null,
          tamanio: null,
          color: null,
          placas: null,
          duracionHr: null,
          duracionMin: null,
          duracionSeg: null,
          infAdicional: null
        }
      }
    });
  };

  const formComponent = ({ key, remove, name, disabled, isLastHallazgo, ...restField }) => (
    <div>
      <div className="formulario-hallazgos">
        <Row gutter={24}>
          <Col xs={12} className="formulario-hallazgos-tabla-header">
            Datos del hallazgo
          </Col>
          <Col xs={9} className="formulario-hallazgos-tabla-header">
            Muestras
          </Col>
          <Col xs={3} style={{ textAlign: 'center' }} className="formulario-hallazgos-tabla-header">
            Acciones
          </Col>
        </Row>

        <Row>
          <Col xs={12} className="hallazgos-detalle">
            <Row gutter={24}>
              <Col xs={9}>
                <Form.Item
                  {...restField}
                  name={[name, 'tipoHallazgo']}
                  label="Tipo de hallazgo:"
                  rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  <Select
                    disabled={disabled}
                    fieldNames={{ value: 'idHallazgo', label: 'nombreHallazgo' }}
                    placeholder="Selecciona un tipo de hallazgo"
                    options={tipoHallazgos}
                    onChange={() => onChangeTipoHallazgo(key)}
                    filterOption={(inputValue, option) =>
                      option.nombreHallazgo?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  return (
                    // TODO CAMBIAR A INDEX
                    prevValues.hallazgos[key]?.tipoHallazgo !==
                    curValues.hallazgos[key]?.tipoHallazgo
                  );
                }}>
                {() => {
                  // console.log('jjj', form.getFieldsValue()?.hallazgos);
                  const listaAtributos =
                    tipoHallazgos
                      .find(
                        (tipo) =>
                          tipo.idHallazgo === form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo
                      )
                      ?.atributos?.split(',') || [];
                  const atributosInputs = [];
                  if (listaAtributos.includes(findAtributoByName('idINE'))) {
                    atributosInputs.push(
                      <Col xs={6}>
                        <Form.Item
                          name={[name, 'isIdINE']}
                          label="¿Cuenta con ID INE?"
                          rules={[{ required: true, message: fieldMsgs.ERR_RADIO_FIELD_REQUIRED }]}>
                          <Radio.Group className="radiog radio-style">
                            <Radio value={1}>Sí</Radio>
                            <Radio value={0}>No</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>,
                      <Col xs={9}>
                        <Form.Item {...restField} name={[name, 'idINE']} label="ID INE:">
                          <Input placeholder="Escribe..." disabled={disabled} />
                        </Form.Item>
                      </Col>
                    );
                  }
                  return atributosInputs;
                }}
              </Form.Item>
            </Row>
            <Row gutter={[8, 0]} className="row-form-components">
              {' '}
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  return (
                    // TODO CAMBIAR A INDEX
                    prevValues.hallazgos[key]?.tipoHallazgo !==
                    curValues.hallazgos[key]?.tipoHallazgo
                  );
                }}>
                {() => {
                  const listaAtributos =
                    tipoHallazgos
                      .find(
                        (tipo) =>
                          tipo.idHallazgo === form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo
                      )
                      ?.atributos?.split(',') || [];

                  const atributosInputs = [];
                  if (listaAtributos.includes(findAtributoByName('nombre'))) {
                    atributosInputs.push(
                      <Col>
                        <Form.Item
                          {...restField}
                          name={[name, 'subTipoHallazgo']}
                          label="Nombre:"
                          rules={[
                            {
                              required:
                                form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo == 124
                                  ? false
                                  : true, // MNI - Si es "Otros, visitas" no será obligatorio, solo para este.
                              message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                            }
                          ]}>
                          <Input placeholder="Escribe..." disabled={disabled} />
                        </Form.Item>
                      </Col>
                    );
                  }
                  if (listaAtributos.includes(findAtributoByName('cantidad'))) {
                    atributosInputs.push(
                      <Col xs={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'cantidad']}
                          label="Cantidad:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input placeholder="Escribe..." disabled={disabled} />
                        </Form.Item>
                      </Col>
                    );
                  }
                  if (listaAtributos.includes(findAtributoByName('idTipoMedida'))) {
                    atributosInputs.push(
                      <Col xs={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'tipoMedida']}
                          label="Tipo medida:"
                          rules={[
                            { required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }
                          ]}>
                          <Select
                            disabled={disabled}
                            fieldNames={{ value: 'descripcion', label: 'descripcion' }}
                            placeholder="Selecciona un tipo de medida"
                            options={tiposMedida}
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                  if (listaAtributos.includes(findAtributoByName('medida'))) {
                    atributosInputs.push(
                      <Col xs={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'medida']}
                          label="Medida:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input placeholder="Escribe..." disabled={disabled} />
                        </Form.Item>
                      </Col>
                    );
                  }
                  if (listaAtributos.includes(findAtributoByName('tamanio'))) {
                    atributosInputs.push(
                      <Col xs={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'tamanio']}
                          label="Tamaño:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input placeholder="Escribe..." disabled={disabled} />
                        </Form.Item>
                      </Col>
                    );
                  }
                  if (listaAtributos.includes(findAtributoByName('color'))) {
                    atributosInputs.push(
                      <Col>
                        <Form.Item
                          {...restField}
                          name={[name, 'color']}
                          label="Color:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input placeholder="Escribe..." disabled={disabled} />
                        </Form.Item>
                      </Col>
                    );
                  }
                  return atributosInputs;
                }}
              </Form.Item>
            </Row>
            <Row gutter={[8, 0]} className="row-form-components">
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  return (
                    prevValues.hallazgos[key]?.tipoHallazgo !==
                    curValues.hallazgos[key]?.tipoHallazgo
                  );
                }}>
                {() => {
                  const listaAtributos =
                    tipoHallazgos
                      .find(
                        (tipo) =>
                          tipo.idHallazgo === form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo
                      )
                      ?.atributos?.split(',') || [];

                  const atributosInputs = [];
                  if (listaAtributos.includes(findAtributoByName('lema'))) {
                    atributosInputs.push(
                      <Col xs={20}>
                        <Form.Item
                          {...restField}
                          name={[name, 'lema']}
                          label="Lema:"
                          rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                          <Input.TextArea
                            style={{ resize: 'none' }}
                            disabled={disabled}
                            placeholder="Escribe.."
                            rows={1}
                            showCount
                            maxLength={200}
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                  if (listaAtributos.includes(findAtributoByName('placas'))) {
                    atributosInputs.push(
                      <Col xs={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'placas']}
                          label="Placas:"
                          rules={[
                            {
                              required:
                                form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo == 124
                                  ? false
                                  : true, // MNI - Si es "Otros, visitas" no será obligatorio, solo para este.
                              message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                            }
                          ]}>
                          <Input disabled={disabled} placeholder="Escribe.." />
                        </Form.Item>
                      </Col>
                    );
                  }
                  return atributosInputs;
                }}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  return (
                    prevValues.hallazgos[key]?.tipoHallazgo !==
                    curValues.hallazgos[key]?.tipoHallazgo
                  );
                }}>
                {() => {
                  const listaAtributos =
                    tipoHallazgos
                      .find(
                        (tipo) =>
                          tipo.idHallazgo === form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo
                      )
                      ?.atributos?.split(',') || [];

                  const atributosInputs = [];
                  if (
                    listaAtributos.includes(findAtributoByName('duracionHr')) ||
                    listaAtributos.includes(findAtributoByName('duracionMin')) ||
                    listaAtributos.includes(findAtributoByName('duracionSeg'))
                  ) {
                    atributosInputs.push(
                      <Form.Item label="Duración:">
                        <Col xs={24}>
                          <div className="div-reloj-campo-completo">
                            <div>
                              <IconReloj className="reloj-icon-completo" />
                            </div>
                            {listaAtributos.includes(findAtributoByName('duracionHr')) && (
                              <>
                                <Form.Item
                                  name={[name, 'duracionHr']}
                                  className="item-duracion-evento">
                                  <InputNumber
                                    className="reloj-input-completo"
                                    placeholder="00"
                                    min={0}
                                    max={24}
                                    keyboard
                                  />
                                </Form.Item>
                                <div className="div-p-time">
                                  <p>hrs.</p>
                                </div>
                              </>
                            )}

                            {listaAtributos.includes(findAtributoByName('duracionMin')) && (
                              <>
                                <Form.Item
                                  name={[name, 'duracionMin']}
                                  className="item-duracion-evento">
                                  <InputNumber
                                    className="reloj-input-completo"
                                    placeholder="00"
                                    min={0}
                                    max={60}
                                    keyboard
                                  />
                                </Form.Item>
                                <div className="div-p-time">
                                  <p>min.</p>
                                </div>
                              </>
                            )}
                            {listaAtributos.includes(findAtributoByName('duracionSeg')) && (
                              <>
                                <Form.Item
                                  name={[name, 'duracionSeg']}
                                  className="item-duracion-evento">
                                  <InputNumber
                                    className="reloj-input-completo"
                                    placeholder="00"
                                    min={0}
                                    max={60}
                                    keyboard
                                  />
                                </Form.Item>
                                <div className="div-p-time">
                                  <p>seg.</p>
                                </div>
                              </>
                            )}
                          </div>
                        </Col>
                      </Form.Item>
                    );
                  }
                  return atributosInputs;
                }}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  return (
                    // TODO CAMBIAR A INDEX
                    prevValues.hallazgos[key]?.tipoHallazgo !==
                    curValues.hallazgos[key]?.tipoHallazgo
                  );
                }}>
                {() => {
                  const listaAtributos =
                    tipoHallazgos
                      .find(
                        (tipo) =>
                          tipo.idHallazgo === form.getFieldsValue()?.hallazgos?.[key]?.tipoHallazgo
                      )
                      ?.atributos?.split(',') || [];

                  const atributosInputs = [];
                  if (listaAtributos.includes(findAtributoByName('infAdicional'))) {
                    atributosInputs.push(
                      <Col xs={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'infAdicional']}
                          label="Información adicional:">
                          <Input.TextArea
                            style={{ resize: 'none' }}
                            disabled={disabled}
                            placeholder="Escribe..."
                            rows={6}
                            showCount
                            maxLength={1200}
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                  return atributosInputs;
                }}
              </Form.Item>
            </Row>
          </Col>
          <Col xs={9}>
            <div className="hallazgos-imagenes">
              <span className="subtitulo-descripcion">Captura de 2 a 5 muestras.</span>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  required
                  name={[name, 'muestra_1']}
                  label="Muestra 1"
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
                <Form.Item
                  required
                  {...restField}
                  name={[name, 'muestra_2']}
                  label="Muestra 2"
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_3']}
                  label="Muestra 3"
                  className="hallazgos-imagenes-muestra">
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
              </div>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_4']}
                  label="Muestra 4"
                  className="hallazgos-imagenes-muestra">
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_5']}
                  label="Muestra 5"
                  className="hallazgos-imagenes-muestra">
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
              </div>
            </div>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-acciones">
              <Button disabled={isLastHallazgo} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(name)} />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return (
    <div className="modal-monitoreo-internet-hallazgos">
      <span className="seccion-hallazgos-titulo">Agrega los hallazgos necesarios.</span>
      <Form layout="vertical" form={form}>
        <Form.List name="hallazgos" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => {
                  const isLastHallazgo = fields.length <= 1;

                  const hallazgo = {
                    key: `hallazgo_${key}`,
                    label: `Hallazgo ${name + 1}`,
                    forceRender: true,
                    children: formComponent({ key, remove, name, isLastHallazgo, ...restField })
                  };
                  return (
                    <Accordion
                      key={key}
                      items={[hallazgo]}
                      defaultActiveKey={[`hallazgo_${key}`]}
                    />
                  );
                })}
                <Divider />
                <div className="formulario-hallazgos-acciones">
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '1em' }}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

Hallazgos.propTypes = {
  form: PropTypes.shape({ getFieldsValue: PropTypes.func, getFieldValue: PropTypes.func })
    .isRequired,
  isLoadingImages: PropTypes.bool.isRequired
};

export default Hallazgos;
